export const version = 'v2.2.4-2108-gf9dbbaf9a'
